<app-error-summary [error]="scope.error" *ngIf="scope.error"></app-error-summary>
<div class="banner" *ngIf="scope.updated" [ngClass]="{'disabled--loading': scope.loading}">
    <h2 class="banner__text" [innerText]="scope.getText | transform:'PREFERENCES_UPDATED'"></h2>
</div>
<dynamic-form (submit)="scope.updatePreferences($event)" [fields]="scope.fieldConfig"></dynamic-form>
